/* Bo's Garage TPMS page: kit buttons, rig finder, cover-first gallery */
(() => {
  if (window.bosTpms) return;
  window.bosTpms = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wheelsOf = (text) => parseInt(text, 10) || 0;

  // Select a kit in the main product form and bring the buy box into view. The radios carry option IDs,
  // so the kit is read from each radio's label ("4 wheels"…).
  const pickKit = (wheels) => {
    const form = document.querySelector('.shopify-section--main-product');
    const radio = form && [...form.querySelectorAll('.variant-picker input[type="radio"]')]
      .find((input) => wheelsOf(form.querySelector(`label[for="${input.id}"]`)?.textContent.trim()) === wheels);
    if (!radio) return false;
    radio.click();
    (document.getElementById('buy') || form).scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    return true;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tpms-kit]');
    if (!button) return;
    pickKit(Number(button.dataset.tpmsKit));
    button.closest('details')?.removeAttribute('open');
  });

  // Kit hint: the native <details> opens the list; closing plays a short fade first. A tap outside closes it too.
  const closeHint = (hint) => {
    hint.classList.add('is-closing');
    setTimeout(() => { hint.classList.remove('is-closing'); hint.open = false; }, reduced ? 0 : 130);
  };
  document.addEventListener('click', (event) => {
    const hint = document.querySelector('.bos-tpms-hint[open]:not(.is-closing)');
    if (!hint) return;
    const onSummary = event.target.closest('summary')?.parentElement === hint;
    if (onSummary) event.preventDefault();
    if (onSummary || !hint.contains(event.target) || event.target.closest('.bos-tpms-hint__panel a')) closeHint(hint);
  });

  // Rig finder, one question at a time: rig type → what pulls it → axles (or towed car) → tire count →
  // smallest kit that covers it. Nothing starts selected: only what the customer taps turns blue.
  document.querySelectorAll('[data-bos-tpms-rig]').forEach((root) => {
    const kits = JSON.parse(root.querySelector('[data-rig-kits]').textContent).sort((a, b) => a.wheels - b.wheels);
    const out = (name) => root.querySelector(`[data-rig-${name}]`);
    const action = out('action');
    const checked = (name) => root.querySelector(`input[name="${name}"]:checked`);
    const clear = (...names) => names.forEach((name) => root.querySelectorAll(`input[name="${name}"]`).forEach((input) => { input.checked = false; }));
    const steps = [...root.querySelectorAll('[data-rig-step]')];
    const visible = () => steps.filter((s) => !s.hidden);
    let match = null;
    let step = 1;

    const showKind = (kind) => {
      root.querySelectorAll('[data-for-kind]').forEach((el) => {
        el.hidden = !el.dataset.forKind.split(' ').includes(kind);
      });
      root.querySelector('[data-rig-q="axles"]').hidden = kind === 'truck';
    };

    const showResult = () => {
      const type = checked('bos-rig-type');
      const pull = Number(checked('bos-rig-pull')?.value || 0);
      const extra = type?.dataset.kind === 'truck' ? 0 : Number(checked('bos-rig-axles')?.value || 0);
      const tires = pull + extra;
      out('count').textContent = root.dataset.textCount.replace('[count]', tires);
      out('tip').textContent = type?.dataset.tip || '';
      match = kits.find((kit) => kit.wheels >= tires) || null;
      if (match) {
        const spare = match.wheels - tires;
        out('kit').textContent = root.dataset.textKit.replace('[wheels]', match.wheels);
        out('price').innerHTML = `<strong>${match.price}</strong>${match.compare ? ` <s>${match.compare}</s>` : ''}${spare ? `<small>${root.dataset.textSpare.replace('[spare]', spare)}</small>` : ''}`;
        action.textContent = root.dataset.textButton.replace('[wheels]', match.wheels);
        action.href = match.url;
        action.hidden = false;
      } else {
        out('kit').textContent = root.dataset.textTooMany;
        out('price').textContent = '';
        action.hidden = true;
      }
    };

    const show = (n) => {
      const list = visible();
      step = Math.min(Math.max(n, 1), list.length + 1);
      const done = step > list.length;
      root.dataset.stage = done ? 'done' : 'ask';
      list.forEach((s, i) => s.classList.toggle('is-current', i === step - 1));
      out('progress').textContent = done ? '' : `Question ${step} of ${list.length}`;
      out('back').hidden = step === 1;
      if (done) showResult();
      // The kit card lights up and its rig photo shows only once every question is answered.
      const cards = [...root.querySelectorAll('[data-rig-card]')];
      cards.forEach((card) => card.classList.toggle('is-match', done && !!match && Number(card.dataset.rigCard) === match.wheels));
      const card = cards.find((c) => c.classList.contains('is-match'));
      out('shot').innerHTML = card ? card.querySelector('.bos-tpms-rig__photo').innerHTML : '';
      const shot = out('shot').querySelector('img');
      if (shot) { shot.loading = 'eager'; shot.sizes = '(max-width: 999px) 90vw, 480px'; }
    };

    root.addEventListener('change', (event) => {
      // A new rig type asks its own follow-up questions from scratch.
      if (event.target.name !== 'bos-rig-type') return;
      clear('bos-rig-pull', 'bos-rig-axles');
      showKind(event.target.dataset.kind);
    });
    root.addEventListener('click', (event) => {
      const current = event.target.closest('input[type="radio"]')?.closest('[data-rig-step]');
      if (!current) return;
      // A tick later, so the tapped answer shows blue and the change handler has set up the next question.
      setTimeout(() => show(visible().indexOf(current) + 2), 150);
    });
    out('back').addEventListener('click', () => show(step - 1));
    out('restart').addEventListener('click', () => {
      clear('bos-rig-type', 'bos-rig-pull', 'bos-rig-axles');
      showKind('trailer');
      match = null;
      show(1);
      root.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
    action.addEventListener('click', (event) => {
      if (match && pickKit(match.wheels)) event.preventDefault();
    });
    // Browsers can restore old radio choices on reload; start clean.
    clear('bos-rig-type', 'bos-rig-pull', 'bos-rig-axles');
    showKind('trailer');
    show(1);
  });

  // The page opens on gallery frame 1 (the cover), not on the selected kit's card; a kit card shows once the
  // customer changes the kit, or when a link opens a specific kit (?variant=).
  if (!new URLSearchParams(location.search).has('variant')) {
    // On phones the carousel scrolls to the kit's card on its own after layout, so wait for the page load.
    const loaded = document.readyState === 'complete' ? Promise.resolve() : new Promise((resolve) => window.addEventListener('load', resolve, { once: true }));
    Promise.all([customElements.whenDefined('media-carousel'), loaded]).then(() => setTimeout(() => {
      document.querySelector('.shopify-section--main-product media-carousel')?.select?.(0, { instant: true });
    }, 100));
  }
})();
